<template>
  <div class="set-new-password">
    <div class="set-new-password-header">
      <div class="set-new-password-header__wrapper">
        <template v-if="isDesktop">
          <a href="/">
            <div class="set-new-password-header__wrapper__logo">
              <img src="/assets/img/logo-header-review.svg" alt="logo-soco" />
            </div>
          </a>
          <!-- <div class="set-new-password-header__wrapper__buttons">
                        <button class="button sign-in" @click.prevent="toggleModalAuth(1)">Masuk</button>
                        <button class="button sign-up" @click.prevent="toggleModalAuth(2)">Daftar</button>
                    </div> -->
        </template>
        <template v-else>
          <a href="/">
            <div class="set-new-password-header__wrapper__arrow">
              <img src="/assets/img/arrow_left.svg" alt="arrow-left" />
            </div>
          </a>
          <div class="set-new-password-header__wrapper__label">
            <p>LUPA PASSWORD</p>
          </div>
        </template>
      </div>
    </div>
    <div class="set-new-password-body">
      <div class="set-new-password-body__wrapper">
        <div class="set-new-password-body__wrapper__title">
          <p class="title">PASSWORD BARU</p>
          <p class="sub-title">Masukkan password baru kamu</p>
        </div>
        <div class="set-new-password-body__wrapper__form">
          <form method="post" @submit.prevent="submitNewPassword">
            <div :class="[{ 'has-error': errors.has('newPassword') }, 'field']">
              <label class="text-label" for="newPassword">Password Baru <span class="required">*</span></label>
              <div class="fieldarea fieldarea--password">
                <input
                  id="newPassword"
                  ref="newPassword"
                  v-model="newPassword"
                  v-validate
                  :type="reveal.password ? 'text' : 'password'"
                  class="text form-control"
                  placeholder=""
                  name="newPassword"
                  data-vv-rules="required"
                />
                <span :class="[{ show: reveal.password }, 'icon-reveal']" @click="togglePassword('password')" />
                <p v-show="errors.has('newPassword')" class="text-alert">
                  {{ errors.first('newPassword') }}
                </p>
              </div>
            </div>
            <div :class="[{ 'has-error': errors.has('confirmPassword') }, 'field']">
              <label class="text-label" for="confirmPassword"
                >Konfirmasi Password Baru <span class="required">*</span></label
              >
              <div class="fieldarea fieldarea--password">
                <input
                  id="confirmPassword"
                  v-model="confirmPassword"
                  v-validate
                  :type="reveal.confirmPassword ? 'text' : 'password'"
                  class="text form-control"
                  placeholder=""
                  name="confirmPassword"
                  data-vv-rules="required|confirmed:newPassword"
                />
                <span
                  :class="[{ show: reveal.confirmPassword }, 'icon-reveal']"
                  @click="togglePassword('confirmPassword')"
                />
                <p v-show="errors.has('confirmPassword')" class="text-alert">
                  {{ errors.first('confirmPassword') }}
                </p>
              </div>
            </div>
            <div class="formaction">
              <button
                v-if="showLoader == false"
                type="submit"
                class="button button_danger"
                :disabled="
                  errors.has('newPassword') || errors.has('confirmPassword') || !newPassword || !confirmPassword
                "
              >
                SET PASSWORD
              </button>
              <loader-spin v-else></loader-spin>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- <div class="set-new-password-footer" v-show="isDesktop">
            <div class="set-new-password-footer__wrapper">
                <img src="/assets/img/set-new-password-footer.svg" alt="footer">
                <span>PT. Social Bella 2018, All Rights Reserved.</span>
            </div>
        </div> -->
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
import errorMessageSwitcher from '@/shared/mixins/ErrorMessageSwitcher';
import LoaderSpin from '@/shared/UIComponents/LoaderSpin';
export default {
  name: 'set-new-password',
  components: {
    LoaderSpin,
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      showLoader: false,
      reveal: {
        password: false,
        confirmPassword: false,
      },
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    isSetNewPasswordMode() {
      return this.$store.state.isSetNewPasswordMode;
    },
  },
  methods: {
    togglePassword(input) {
      this.reveal[input] = !this.reveal[input];
    },
    submitNewPassword() {
      this.showLoader = true;
      const validate = this.$validator.validateAll();
      if (validate) {
        const payload = {
          user_id: this.$store.state.tempUserId,
          code: this.$store.state.otpNumber,
          new_password: this.newPassword,
        };
        axios
          .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/reset-password`, payload)
          .then((response) => {
            if (response.data.success) {
              this.$toasted.global.show('Password berhasil diubah');
              setTimeout(() => {
                this.$router.push('/');
              }, 200);
            }
          })
          .catch((error) => {
            const err = errorMessageSwitcher(error.response.data.errorCode.toLowerCase());
            this.$toasted.global.error(err);
          })
          .finally(() => (this.showLoader = false));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.set-new-password {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-top: -30px;
  // height: 100vh;
  display: flex;
  flex-direction: column;
  &-header {
    &__wrapper {
      display: flex;
      padding: 45px 120px 22px 120px;
      justify-content: space-between;
      border-bottom: 1px #e5e5e5 solid;
      align-items: center;
      &__buttons {
        display: flex;
        .button {
          width: 113px;
          &.sign-up {
            background: #f083a6;
            border-radius: 2px;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: normal;
            border: none;
            text-transform: uppercase;
            padding: 6px 24px;
            font-family: 'lato-bold';
          }
          &.sign-in {
            background-color: #fff;
            color: #f083a6;
            margin-right: 10px;
          }
        }
      }
      &__logo {
        height: 34px;
      }
    }
  }
  &-body {
    flex: 1;
    .required {
      color: #da2a52;
    }
    &__wrapper {
      height: 100%;
      padding: 60px 0;
      width: 30%;
      margin: auto;
      text-align: left;
      &__title {
        .title {
          font-family: 'lato-bold';
          font-size: 18px;
          letter-spacing: normal;
          text-align: center;
          margin-bottom: 16px;
        }
        .sub-title {
          font-size: 14px;
          letter-spacing: 0;
          text-align: center;
          line-height: 14px;
        }
      }
      &__form {
        margin-top: 57px;
        .fieldarea--password {
          position: relative;
        }
        .text-label {
          font: normal 13px/20px 'Lato-Regular', sans-serif;
          margin: 0 0 8px;
          color: #8c8582;
          display: inline-block;
        }
        .formaction {
          margin-top: 40px;
        }
        .form-control {
          border: 1px solid #e5e5e5;
          border-radius: 4px;
          width: 100%;
          margin: 0;
          height: 40px;
          font: normal 14px 'Lato-Regular', sans-serif;
        }
        .icon-reveal {
          top: 13px;
          position: absolute;
          right: 0;
          width: 44px;
          height: 14px;
          background: transparent url(/assets/img/icon-hide-password.svg) no-repeat center center;
          &:hover {
            cursor: pointer;
          }
        }
        .button_danger {
          display: block;
          width: 100%;
          height: 36px;
          border: 0;
          padding: 8px 0;
          margin: 0;
          font: normal 13px/18px 'lato-bold', sans-serif;
          background: #da2a52;
          color: #ffffff;
          letter-spacing: normal;
          text-align: center;
          border-radius: 4px;
        }
        .text-alert {
          font: 13px/16px 'lato-regular';
          color: #da2a52;
          margin-top: 6px;
        }
      }
    }
  }
  &-footer {
    &__wrapper {
      position: relative;
      img {
        width: 100%;
      }
      span {
        position: absolute;
        top: 50%;
        right: 156px;
        transform: translateY(-50%);
        font-size: 12px;
        color: #8c8582;
        letter-spacing: 0;
        line-height: 26.5px;
      }
    }
  }
}
@media (max-width: 991px) {
  .set-new-password {
    &-header {
      &__wrapper {
        padding: 43px 18px 10px;
        justify-content: flex-start;
        &__label {
          p {
            margin-bottom: 0;
            margin-left: 18px;
            font-size: 14px;
            letter-spacing: normal;
            font-family: 'lato-bold';
          }
        }
        &__arrow {
          img {
            vertical-align: sub;
          }
        }
      }
    }
    &-body {
      &__wrapper {
        padding: 0 15px;
        width: auto;
        margin: 0;
        &__title {
          margin-top: 45px;
        }
        &__form {
          margin-top: 24px;
          .formaction {
            margin-top: 24px;
          }
        }
      }
    }
  }
}
</style>
